import React, {Component} from "react";

import Ecg from '../../Ecg';

import DiagnosticSelect from '../../DiagnosticSelect';
import Mousetrap from 'mousetrap';
/*
* Authentication
*/
import Alt from 'alt';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';

//Twilio
import $ from 'jquery';
import TwilioSDK from '../../../components/twilio';
import twilioInstance from "../../../twilioInstance.js";
import twilioChatClient from "../../../twilioChatClient.js";
import TwilioChat from 'twilio-chat';

import Constants from '../../../Components/Constants'


import {
  Alert,
  Badge,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  CardBlock,
  CardFooter,
  CardTitle,
  Button,
  Label,
  Input,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Media, InputGroup, InputGroupAddon
} from "reactstrap";

import classnames from "classnames";
import EcgPanel from '../../EcgPanel';
import Widget02 from '../../Widgets/Widget02';
import AlertContainer from 'react-alert';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

class ExamViewer extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);

        this.toggleModalCompareExams = this.toggleModalCompareExams.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.sendReport = this.sendReport.bind(this);
		this.sendManualReport = this.sendManualReport.bind(this);
        this.onDerivationClick = this.onDerivationClick.bind(this);

        this.reportTextChange = this.reportTextChange.bind(this);
        this.obsChange = this.obsChange.bind(this);
        this.addDiag = this.addDiag.bind(this);
        this.resetDiags = this.resetDiags.bind(this);
        this.isCategoryEmpty = this.isCategoryEmpty.bind(this);
        this.isReportComplete = this.isReportComplete.bind(this);
        this.checkReportComplete = this.checkReportComplete.bind(this);
        this.markAsNormal = this.markAsNormal.bind(this);
        this.getDiagById = this.getDiagById.bind(this);

        this.refreshReportText = this.refreshReportText.bind(this);
        this.cancelReport = this.cancelReport.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.updateValueComparableExamDerivation = this.updateValueComparableExamDerivation.bind(this);
        this.compareExams = this.compareExams.bind(this);
        this.generateServiceProtocol = this.generateServiceProtocol.bind(this);

        this.cleanDiagnosticsAndReport = this.cleanDiagnosticsAndReport.bind(this);

        this.markAsNormalAndSend = this.markAsNormalAndSend.bind(this);

        //Alerts
        this.showAlert = this.showAlert.bind(this);

        this.formatDate = this.formatDate.bind(this);
        this.toggleCalling = this.toggleCalling.bind(this);
        this.initChat = this.initChat.bind(this);

        this.state = {
            examId: this.props.match.params.examId,
            exam: null,
            activeTab: '2',
            calling: false,
            serviceProtocol: null,

            tab01enabled: true,
            tab02enabled: true,
            tab03enabled: false,
            tab04enabled: true,  //a aba de laudo deve ficar habilitada sempre

            reportDerivation: 1,
            reportDerivationName: "II",
            measurements: null,
            derivations: new Array(12),

            timeZoom: 1,
            gainZoom:1,

            categories: null,
            diagnostics: [],
            reportText: "",
            obs: "",
            isReportComplete: false,

            modalRepeatExam: false,
            modalCompareExam: false,
            anteriorExams: [],
            anteriorExamSelect: undefined,
            comparableExam: null,
            comparableExamDerivations: new Array(12),
            comparableExamDerivation: 1,

            //Equipment - array para verificação se mostra o começo ou o final do traçado
            //TODO remover do state e inserir em ENUM ou Constants

            equipamentStartFromInit: {
              "EQUIPMENT_AEROTEL": 1,
              "EQUIPMENT_TEB": 0,
              "EQUIPMENT_CARDIOWEB_SERVER": 1,
              "EQUIPMENT_CARDIOWEB_CLIENT": 1,
              "EQUIPMENT_PHYSIO_GLOVE": 0,
              "EQUIPMENT_MICROMED_600": 1,
              "EQUIPMENT_MICROMED_300": 1,
              "EQUIPMENT_EPEOPLE": 1,
              "EQUIPMENT_VENTRIX": 1,
			        "EQUIPMENT_BIONET_CARDIOXP": 0,
              "EQUIPMENT_HW": 1
            },

            dln: false
        };

        let examId = this.props.match.params.examId;

        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/exam/'+examId,
            data: this.props.searchFilter
        })
        .then(response => {
          let derivations = null;

            if (response.data.ecgData != null) {
              //Separa as derivações do ECGDATA
              let amostras = response.data.ecgData.split(',');
              let nAmostras = amostras.length / 12;              
              derivations = new Array(12);

              for (let x = 0; x < 12; x++) {
                derivations[x] = new Array(nAmostras);
              }
  
              for (let i = 0; i < amostras.length; i++) {
                  let d = parseInt(i % 12);
                  let pos = parseInt(i / 12);
  
                  derivations[d][pos] = amostras[i];
              }
            }

            //Busca exames anteriores
            axios({
                method: 'get',
                url: Constants.apiUrl+'/api/v1/exam/patient/'+response.data.patient.id
            })
            .then(res => {
              let anteriorExamsList = [];

              
              res.data.forEach(anteriorExam => {
                let receivedDate = new Date(anteriorExam.dtReceived);
                let formatedDate =  this.formatDate(receivedDate);
                
                if(anteriorExam.id != this.state.exam.id){
                  anteriorExamsList.push({
                    value: anteriorExam.id,
                    label: anteriorExam.publicId + " "+ formatedDate
                  });
                }

                this.setState({
                    anteriorExams: anteriorExamsList
                });
              });
            });


            this.setState({
                exam: response.data,
                derivations: derivations
            });

            //Seta exame como 'EM LAUDO'
            //@RequestMapping(value="/status/", method = RequestMethod.POST)
    	      //public Boolean setExamStatus(@RequestParam String examId, @RequestParam String newStatus, @RequestParam String doctorId, @RequestParam String doctorName) {

            if(response.data.status != 'EXAM_STATUS_REPORTED' && AuthStore.getState().user.profile == 'M'){
              axios({
                  method: 'post',
                  url: Constants.apiUrl+'/api/v1/exam/status?examId='+examId+
                    '&newStatus=EXAM_STATUS_WAITING_REPORT'+
                    '&doctorId='+AuthStore.getState().user.entity_id+
                    '&doctorName='+AuthStore.getState().user.entity_name
              })
              .then(response => {
                // Alterou status...
              });
            }


            //Apenas visualização do exame
            if(response.data.status == 'EXAM_STATUS_REPORTED' || response.data.status == 'EXAM_STATUS_PREREPORTED' || response.data.preReport != null){
              let tokens = response.data.measurements!= null ? response.data.measurements.split(',') : [];

              let examMeasurements = {
                HR: typeof tokens[1] == 'undefined' ? 0 : parseFloat(tokens[1].substr(tokens[1].indexOf('=')+1, tokens[1].length - tokens[1].indexOf('='))),
                RR: typeof tokens[4] == 'undefined' ? 0 :parseFloat(tokens[4].substr(tokens[4].indexOf('=')+1, tokens[4].length - tokens[4].indexOf('='))),
                PR: typeof tokens[12] == 'undefined' ? 0 :parseFloat(tokens[12].substr(tokens[12].indexOf('=')+1, tokens[12].length - tokens[12].indexOf('='))),
                T: typeof tokens[5] == 'undefined' ? 0 :parseFloat(tokens[5].substr(tokens[5].indexOf('=')+1, tokens[5].length - tokens[5].indexOf('='))),
                QRS: typeof tokens[6] == 'undefined' ? 0 :parseFloat(tokens[6].substr(tokens[6].indexOf('=')+1, tokens[6].length - tokens[6].indexOf('='))),
                QT: typeof tokens[10] == 'undefined' ? 0 :parseFloat(tokens[10].substr(tokens[10].indexOf('=')+1, tokens[10].length - tokens[10].indexOf('='))),
                Q: typeof tokens[8] == 'undefined' ? 0 :parseFloat(tokens[8].substr(tokens[8].indexOf('=')+1, tokens[8].length - tokens[8].indexOf('='))),
                P: typeof tokens[9] == 'undefined' ? 0 :parseFloat(tokens[9].substr(tokens[9].indexOf('=')+1, tokens[9].length - tokens[9].indexOf('='))),
                PQ: typeof tokens[11] == 'undefined' ? 0 :parseFloat(tokens[11].substr(tokens[11].indexOf('=')+1, tokens[11].length - tokens[11].indexOf('='))),
                QTc: typeof tokens[3] == 'undefined' ? 0 :parseFloat(tokens[3].substr(tokens[3].indexOf('=')+1, tokens[3].length - tokens[3].indexOf('='))),
                ST: typeof tokens[7] == 'undefined' ? 0 :parseFloat(tokens[7].substr(tokens[7].indexOf('=')+1, tokens[7].length - tokens[7].indexOf('='))),
                R1: typeof tokens[2] == 'undefined' ? 0 :parseFloat(tokens[2].substr(tokens[2].indexOf('=')+1, tokens[2].length - tokens[2].indexOf('='))),
                R2: typeof tokens[13] == 'undefined' ? 0 :parseFloat(tokens[13].substr(tokens[13].indexOf('=')+1, tokens[13].length - tokens[13].indexOf('='))),
                S: typeof tokens[14] == 'undefined' ? 0 :parseFloat(tokens[14].substr(tokens[14].indexOf('=')+1, tokens[14].length - tokens[14].indexOf('='))),
                R3: typeof tokens[15] == 'undefined' ? 0 :parseFloat(tokens[15].substr(tokens[15].indexOf('=')+1, tokens[15].length - tokens[15].indexOf('='))),
                R4: typeof tokens[16] == 'undefined' ? 0 :parseFloat(tokens[16].substr(tokens[16].indexOf('=')+1, tokens[16].length - tokens[16].indexOf('=')))
              };

              let derivationNames = ["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"];

              let examMarks = {
                P: examMeasurements.P,
                Q: examMeasurements.Q,
                R1: examMeasurements.R1,
                R2: examMeasurements.R2,
                R3: examMeasurements.R3,
                R4: examMeasurements.R4,
                S: examMeasurements.S,
                ST: examMeasurements.ST,
                T: examMeasurements.T
              };

              this.setState({
                tab01enabled: true,
                tab02enabled: true,
                tab03enabled: true,
                tab04enabled: true,

                measurements: examMeasurements,
                marks: examMarks,
                reportDerivation: derivationNames.indexOf(tokens[0].substr(tokens[0].indexOf('=')+1, tokens[0].length - tokens[0].indexOf('='))),
                reportText: response.data.report,
                obs: response.data.reportObs,
                diagnostics: response.data.diagnostics,
                isReportComplete: true
              });
            } // readonly

        })
        .catch(error => {                 
          this.showAlert(error.data.message, 'error');
        });


        /*
        * Configurações do alerta
        */
        this.alertOptions = {
          offset: 14,
          position: 'top right',
          theme: 'light',
          time: 10000,
          transition: 'scale'
        }
    }

    pad(a,b){return(1e15+a+"").slice(-b)}

    formatDate(date){
      return this.pad(date.getDate(), 2) +"/"+this.pad((date.getMonth()+1), 2) +"/"+date.getFullYear() +
      " "+ this.pad(date.getHours(), 2)+":"+this.pad(date.getMinutes()+1, 2)+":"+date.getSeconds();
    }

    updateValue (newValue) {
  		this.setState({
  			anteriorExamSelect: newValue
  		});
  	}

    updateValueComparableExamDerivation (newValue) {
  		this.setState({
  			comparableExamDerivation: newValue
  		});
  	}

    toggleModal() {
      this.setState({
        modalRepeatExam: !this.state.modalRepeatExam
      });
    }

    toggleCalling() {
      this.setState({
        calling: !this.state.calling
      });
    }

    toggleModalCompareExams() {
      this.setState({
        modalCompareExam: !this.state.modalCompareExam
      });
    }

    //Inicia chat com médico disponível
    initChat(){
      let examId = this.state.exam.id;
      let publicId = this.state.exam.publicId;

      twilioChatClient.getOrCreateChannel(examId, publicId);

    }

    cancelReport(){
      let newStatus = "EXAM_STATUS_SENT_TO_REPORT";
      let doctorId = "";
      let doctorName = "";
      //Se exame era pré-laudado, volta ao status EXAM_STATUS_PREREPORTED e volta ao médico residente que executou o pré-laudo
      if(this.state.exam.preReport){
        newStatus = "EXAM_STATUS_PREREPORTED";
        doctorId = this.state.exam.preReport.doctor.id;
        doctorName = this.state.exam.preReport.doctor.name;
      }

      //Cancela laudo - Seta exame como 'AGUARDANDO LAUDO'
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/status?examId='+this.state.examId+
            '&newStatus='+newStatus+
            '&doctorId='+doctorId+
            '&doctorName='+doctorName
      })
      .then(response => {
        this.msg.show('Laudo cancelado...', {
          time: 10000,
          type: 'success'
        });

        this.props.history.push('/dashboard');
      });
    }

    showAlert(message, type='success'){
      this.msg.show(message, {
        time: 10000,
        type: type
      });
    }

    onDerivationClick(derivation){
      //Apenas médicos devem avançar para a tela de marcações e diagnósticos
      if (AuthStore.getState().user.profile != "M") return;

      let derivationNames = ["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"];
      derivation = derivation-1;

      //Se exame estiver laudado, não busca sugestão de marcações - usa-se as que foram definidas pelo médico.
      if(this.state.exam.status == "EXAM_STATUS_REPORTED" || this.state.exam.status == "EXAM_STATUS_PREREPORTED"){
        this.setState({
          reportDerivation: derivation,
          reportDerivationName: derivationNames[derivation],
          tab03enabled: true
        });
        this.toggleTab('3');

        return;
      }

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/exam/'+this.state.examId+'/ecg/'+derivation+'/marks'
      })
      .then(response => {
        this.setState({
          reportDerivation: derivation,
          reportDerivationName: derivationNames[derivation],
          marks: response.data,
          tab03enabled: true
        });

        this.toggleTab('3');

      });
    }
	
	sendManualReport(){
		this.sendReport();
	}
	
    sendReport(){
      let exam = this.state.exam;

      //Marca exame como Laudado
      exam.status = 'EXAM_STATUS_REPORTED';

      //Remove o ECGDATA por questões de performance
      exam.ecgData = null;

      exam.dtReportEnd = new Date();
      exam.report = this.state.reportText;
      exam.reportObs = this.state.obs;
      exam.doctor = {"id": AuthStore.getState().user.entity_id, "name": AuthStore.getState().user.entity_name};
      exam.diagnostics = this.state.diagnostics;

      //Gera string das marcações
      //EX:
      //{trace=V6, HR=53, R1=750.0, QTc=6, RR=1125, T=930.0, QRS=75, ST=0, Q=715.0, P=625.0, QT=215, PQ=90, PR=125, R2=1500.0, S=790.0, R3=2250.0}

      let measurementsStr = "";
      if(this.state.measurements != null){
        measurementsStr += "{";
          measurementsStr += "trace="+this.state.reportDerivationName+",";
          measurementsStr += "HR="+this.state.measurements.HR+", ";
          measurementsStr += "R1="+this.state.measurements.R1+", ";
          measurementsStr += "QTc="+this.state.measurements.QTc+", ";
          measurementsStr += "RR="+this.state.measurements.RR+", ";
          measurementsStr += "T="+this.state.measurements.T+", ";
          measurementsStr += "QRS="+this.state.measurements.QRS+", ";
          measurementsStr += "ST="+this.state.measurements.ST+", ";
          measurementsStr += "Q="+this.state.measurements.Q+", ";
          measurementsStr += "P="+this.state.measurements.P+", ";
          measurementsStr += "QT="+this.state.measurements.QT+", ";
          measurementsStr += "PQ="+this.state.measurements.PQ+", ";
          measurementsStr += "PR="+this.state.measurements.PR+", ";
          measurementsStr += "R2="+this.state.measurements.R2+", ";
          measurementsStr += "S="+this.state.measurements.S+", ";
          measurementsStr += "R3="+this.state.measurements.R3+", ";
          measurementsStr += "R4="+this.state.measurements.R4;
        measurementsStr += "}";
      }
      exam.measurements = measurementsStr;

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/',
          data: exam

      })
      .then(response => {
          this.props.history.push('/dashboard');
      });
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
    }


    /*
    * LAUDO (diagnosticos e texto do laudo)
    */
    reportTextChange(event) {
        this.setState({reportText: event.target.value});
    }

    obsChange(event) {
        this.setState({obs: event.target.value});
    }

    resetDiags(){
      this.setState("diagnostics": []);
    }
    addDiag(diag) {
        let diags = this.state.diagnostics;

        if(diag.category.allowMultipleDiag){
			if (this.state.diagnostics.indexOf(diag) !== -1) {
				diags.splice(diags.indexOf(diag), 1);
			}else{
				diags.push(diag);
			}
        }else{

          if (this.state.diagnostics.indexOf(diag) !== -1) {
            diags.splice(diags.indexOf(diag), 1);
          }else{

            for(var i = 0; i < this.state.diagnostics.length; i++) {
              if(this.state.diagnostics[i].category.id === diag.category.id) {
                diags.splice(diags.indexOf(this.state.diagnostics[i]), 1);
              }
            }

            diags.push(diag);
          }
        }

        let isReportComplete = this.isReportComplete();

        let actualExam = this.state.exam;
        actualExam.normal = false;

        this.setState({
          'isReportComplete': isReportComplete,
          'diagnostics': diags,
          'exam': actualExam
        });

        this.refreshReportText();
        this.checkReportComplete();
    }

    markAsNormal(){

      this.setState({'diagnostics': []}, function(){

        for(var i = 0; i < this.refs.diagnosticSelect.state.categories.length; i++) {
          let normalDiagId = (this.refs.diagnosticSelect.state.categories[i].category.normalDiagId != null 
              && this.refs.diagnosticSelect.state.categories[i].category.normalDiagId != '' 
              && this.state.exam.client.tier == 'SILVER') ? 
                Constants.normalIdSilverTier : 
                this.refs.diagnosticSelect.state.categories[i].category.normalDiagId;

          if(this.getDiagById(normalDiagId) != -1){
            this.addDiag(this.getDiagById(normalDiagId, this.refs.diagnosticSelect.state.categories[i].category.id));
            this.refs.diagnosticSelect.state.categoryApplicability[this.refs.diagnosticSelect.state.categories[i].category.id] = false;
          }else{
            this.refs.diagnosticSelect.state.categoryApplicability[this.refs.diagnosticSelect.state.categories[i].category.id] = true;
          }
        }

        this.checkReportComplete();

        let actualExam = this.state.exam;
        actualExam.normal = true;

        this.setState({
          'exam': actualExam
        });
      });
    }

    getDiagById(diagId, categoryId){
      for(var i = 0; i < this.refs.diagnosticSelect.state.categories.length; i++) {
        for(var j = 0; j < this.refs.diagnosticSelect.state.categories[i].diags.length; j++) {
          if(this.refs.diagnosticSelect.state.categories[i].diags[j].id == diagId)
            return this.refs.diagnosticSelect.state.categories[i].diags[j];
        }
      }

      return -1;
    }

    isCategoryEmpty(categoryId){
      if(this.state.diagnostics == null) return false;
      for(var i = 0; i < this.state.diagnostics.length; i++) {
        if(this.state.diagnostics[i].category.id === categoryId) {
          return false;
        }
      }

      return true;
    }

    checkReportComplete(){
      let isReportComplete = this.isReportComplete();
      this.setState({'isReportComplete': isReportComplete});
    }

    isReportComplete(){
      for(var i = 0; i < this.refs.diagnosticSelect.state.categories.length; i++) {
        if(this.isCategoryEmpty(this.refs.diagnosticSelect.state.categories[i].category.id) && !this.refs.diagnosticSelect.state.categoryApplicability[this.refs.diagnosticSelect.state.categories[i].category.id]) {

          return false;
        }
      }

      return true;
    }

    refreshReportText(){
      let diags = this.state.diagnostics;
      diags = diags.sort(function(a,b){
		return parseInt(a.category.order)  - parseInt(b.category.order);
      });
	  console.log(diags);
	  //Monta texto do laudo
      let reportText = "";
      diags.forEach(function(diag) {
        if(reportText != "") reportText += ", ";
        reportText += diag.content;
      }, this);

      // Texto do QT longo
      if(this.state.exam.qtLongoDetected){
        if(reportText != "") reportText += ", ";
        reportText += "QT Longo";
      }

      /*
        Exame Inválido - monta texto do laudo com parametros de qualidade
        */
      if(reportText != "") reportText += ".";
      if(this.state.exam.repeatExam) reportText += " Repetir exame devido a ";
      if(this.state.exam.artefatos) reportText += " Excesso de Artefatos";
      if(this.state.exam.cabosInvertidos) reportText += " Cabos Invertidos";


      if(reportText != "" && !reportText.endsWith(".")) reportText += ".";

      this.setState({
        diagnostics: diags,
        reportText: reportText
      });
    }

    compareExams(){
      if(this.state.anteriorExamSelect){

        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/exam/'+this.state.anteriorExamSelect
        })
        .then(response => {

          let derivations = null;

          if (response.data.ecgData != null) {
            //Separa as derivações do ECGDATA
            let amostras = response.data.ecgData.split(',');
            let nAmostras = amostras.length / 12;            
            derivations = new Array(12);

            for (let x = 0; x < 12; x++) {
              derivations[x] = new Array(nAmostras);
            }
  
            for (let i = 0; i < amostras.length; i++) {
                let d = parseInt(i % 12);
                let pos = parseInt(i / 12);
  
                derivations[d][pos] = amostras[i];
            }
          }


          this.setState({
            comparableExam: response.data,
            comparableExamDerivations: derivations
          });
          //console.log(this.state.comparableExam);
        });

        this.toggleModalCompareExams();
      }

    }

    getAge(dateString){
      let today = new Date();
      let birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
      {
          age--;
      }
      return age;
    }


    generateServiceProtocol(){
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/protocol/'+this.state.examId
      })
      .then(response => {
        this.setState({'serviceProtocol': response.data});
      });
    }

    //atalhos de teclado
    componentDidMount() {
      Mousetrap.bind(['alt+z'], (e)=>{e.preventDefault();this.toggleTab('1');return false;});
      Mousetrap.bind(['alt+x'], (e)=>{e.preventDefault();this.toggleTab('2');return false;});

      //Cliente não deve acessar as abas de Marcações e Diagnóstico
      if(AuthStore.getState().user.profile != "C"){
        Mousetrap.bind(['alt+c'], (e)=>{e.preventDefault();this.toggleTab('3');return false;});
        Mousetrap.bind(['alt+v'], (e)=>{e.preventDefault();this.toggleTab('4');return false;});
		Mousetrap.bind(['alt+m'], (e)=>{e.preventDefault();this.toggleTab('5');return false;});
      }

      Mousetrap.bind(['0'], (e)=>{

      });
    }

    componentWillUnmount(){
      Mousetrap.reset();
    }

    cleanDiagnosticsAndReport() {
      this.setState({
        diagnostics: [],
        reportText: ''
      });

      for(var i = 0; i < this.refs.diagnosticSelect.state.categories.length; i++) {
        this.refs.diagnosticSelect.state.categoryApplicability[this.refs.diagnosticSelect.state.categories[i].category.id] = false;
      }
    }

    markAsNormalAndSend() {
      this.markAsNormal();
      this.setState({
        dln: true
      })
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.isReportComplete !== this.state.isReportComplete && this.state.dln) {        
        this.sendReport();
      }
    }

    render() {
        if(this.state.exam == null) return (
          <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
        );

        var dtReceived = new Date(this.state.exam.dtReceived);
        var dtReported = new Date(this.state.exam.dtReportEnd);
               
        var isPdf = false;
        var ecgBitmapUrl = "";

        //se o exame tiver img ou pdf
        if(this.state.exam.ecgBitmap) {
          isPdf = this.state.exam.ecgBitmap.includes("application/pdf");
          if (isPdf){
            const base64toBlob = (data) => {
              const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);
          
              const bytes = atob(base64WithoutPrefix);
              let length = bytes.length;
              let out = new Uint8Array(length);
          
              while (length--) {
                out[length] = bytes.charCodeAt(length);
              }
          
              return new Blob([out], { type: 'application/pdf' });
            };

            const blob = base64toBlob(this.state.exam.ecgBitmap);
            ecgBitmapUrl = URL.createObjectURL(blob);
          }
        }

        let derivationNames = ["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"];
        return (
          <div>
              <Row className="exam-viewer-header">

                <Col xs="12" sm="4" md="2">
                  <Media>
                    <Media left>
                      <span className="fa-stack fa-lg">
                        <i className="fa fa-square fa-stack-2x text-default"></i>
                        <i className="fa fa-heartbeat fa-stack-1x fa-inverse"></i>
                      </span>

                    </Media>
                    <Media body className="padding-left">
                      <Media heading className="media-heading-examinfo">
                        {this.state.exam.publicId}
                      </Media>
                      <span>{new Date(this.state.exam.dtReceived).getDate() +'/'+ (new Date(this.state.exam.dtReceived).getMonth()+1)+'/'+new Date(this.state.exam.dtReceived).getFullYear()}</span>
                    </Media>
                  </Media>
                </Col>

                <Col xs="12" sm="4" md="4">
                  <Media>
                    <Media left>
                      <span className="fa-stack fa-lg">
                        <i className={"fa fa-square fa-stack-2x " + (this.state.exam.patient.gender == "FEMALE" ? "text-danger " : "text-primary ")}></i>
                        <i className={(this.state.exam.patient.gender == "FEMALE" ? "fa fa-female " : "fa fa-male ") + " fa-stack-1x fa-inverse"}></i>
                      </span>

                    </Media>
                    <Media body className="padding-left">
                      <Media heading className={"media-heading-examinfo "+ (this.state.exam.patient.gender == "FEMALE" ? "text-danger " : "text-primary ")}>
                        {this.state.exam.patient.firstname +' '+this.state.exam.patient.lastname}
                      </Media>
                      <span>{this.state.exam.patient.gender == "FEMALE" ? "Feminino" : "Masculino"}</span>
                    </Media>
                  </Media>
                </Col>

                <Col xs="12" sm="4" md="2">
                  <Media>
                    <Media left>
                      <span className="fa-stack fa-lg">
                        <i className="fa fa-square fa-stack-2x text-warning"></i>
                        <i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
                      </span>

                    </Media>
                    <Media body className="padding-left">
                      <Media heading className="media-heading-examinfo text-warning">
                        {this.getAge(this.state.exam.patient.dtBirthDate) + " anos"}
                      </Media>
                      <span>Idade</span>
                    </Media>
                  </Media>
                </Col>

                <Col xs="12" sm="4" md="2">
                  <Media>
                    <Media left>
                      <span className="fa-stack fa-lg">
                        <i className="fa fa-square fa-stack-2x text-success"></i>
                        <i className="fa fa-info fa-stack-1x fa-inverse"></i>
                      </span>
                    </Media>
                    <Media body className="padding-left">
                      <Media heading className="media-heading-examinfo text-success">
                        {(this.state.exam.patient.weight == null ? "0 KG, " : this.state.exam.patient.weight + " KG, ") + (this.state.exam.patient.height == null ? "0 m" : this.state.exam.patient.height + " m")}
                      </Media>
                      <span>{"IMC: "+ (this.state.exam.patient.weight == null ? " -" : ''+(this.state.exam.patient.weight / (this.state.exam.patient.height ^ 2)))}</span>
                    </Media>
                  </Media>
                </Col>

                <Col xs="12" sm="2" md="2" className="text-right">
                  <div className={this.state.exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
                    <Button color="danger" onClick={this.cancelReport}>Cancelar Laudo</Button>
                  </div>
                </Col>

              </Row>

            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggleTab('1'); }}
                        disabled={!this.state.tab01enabled}
                        >
                        Informações
                        {'\u00A0'}
                        <div className="shortcut-description">[alt+z]</div>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggleTab('2'); }}
                        disabled={!this.state.tab02enabled}>
                        {this.state.exam.examType == 'EXAM_TYPE_MAPA' ? 'MAPA' : this.state.exam.examType == 'EXAM_TYPE_HOLTER' ? 'HOLTER' : 'ECG'}
                        {'\u00A0'}
                        <div className="shortcut-description">[alt+x]</div>
                    </NavLink>
                </NavItem>

                {AuthStore.getState().user.profile == "M" && !this.state.exam.ecgBitmap && this.state.exam.examType == 'EXAM_TYPE_ECG' ?
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggleTab('3'); }}
                        disabled={!this.state.tab03enabled}>
                        Medição
                        {'\u00A0'}
                        <div className="shortcut-description">[alt+c]</div>
                    </NavLink>
                </NavItem>
                : ""}
                {AuthStore.getState().user.profile == "M" ?
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => { this.toggleTab('4'); }}
                        disabled={!this.state.tab04enabled}>
                        Laudo
                        {'\u00A0'}
                        <div className="shortcut-description">[alt+v]</div>
                    </NavLink>
                </NavItem>
                : ""}
				        {AuthStore.getState().user.profile == "M" && this.state.exam.examType == 'EXAM_TYPE_ECG' ?
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '5' })}
                        onClick={() => { this.toggleTab('5'); }}>
                        Laudo Manual
                        {'\u00A0'}
                        <div className="shortcut-description">[alt+m]</div>
                    </NavLink>
                </NavItem>
                : ""}
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">

                    <Row>
                        <Col xs="12" sm="4" md="4">
                            <h5>Exame</h5>
                            <hr />

                            <b className="info-label">Tipo do exame:</b>
                            <br />
                            <spam className="info-text">
                              {this.state.exam.examType == 'EXAM_TYPE_ECG' ? <Badge color="secondary">ECG</Badge> : ''}
                              {this.state.exam.examType == 'EXAM_TYPE_MAPA' ? <Badge color="info">MAPA</Badge> : ''}
                              {this.state.exam.examType == 'EXAM_TYPE_HOLTER' ? <Badge color="light">HOLTER</Badge> : ''}
                              </spam>
                            <br />

                            <b className="info-label">Antecedentes:</b>
                            <ul className="list-group">
                                {
                                    (this.state.exam != null && this.state.exam.patientAntecedents != null) ?
	                                    this.state.exam.patientAntecedents.map(function(antecedent, i){
	                                        return <li className="list-group-item" key={i}>{antecedent.description}</li>;
	                                    })
	                                    : ''
                                }
                                {
                                    this.state.exam.otherPatientAntecedents != null ?
                                        <li className="list-group-item" key={-1}>{this.state.exam.otherPatientAntecedents}</li>
                                    : ''
                                }
                            </ul>
                            <br />

                            <b className="info-label">Sintomas:</b>
                            <br />
                            <ul className="list-group">

                                {
                                    (this.state.exam != null && this.state.exam.patientSymptoms != null) ?
	                                    this.state.exam.patientSymptoms.map(function(symptom, i){
	                                        return <li className="list-group-item" key={i}>{symptom.description}</li>;
	                                    })
                                    	: ''
                                }
                                {
                                    this.state.exam.otherPatientSymptoms != null ?
                                        <li className="list-group-item" key={-1}>{this.state.exam.otherPatientSymptoms}</li>
                                    : ''
                                }
                            </ul>
                            <br />
                            <b className="info-label">Observações:</b>
                            <br />
                            <spam className="info-text">{ this.state.exam != null ? this.state.exam.obs  : ""} </spam>

                            <br />
                            <b className="info-label">Saturação:</b>
                            <br />
                            <spam className="info-text">{ this.state.exam != null ? this.state.exam.saturation  : ""} </spam>

                            <br />
                            <b className="info-label">Frequência:</b>
                            <br />
                            <spam className="info-text">{ this.state.exam != null ? this.state.exam.frequency  : ""} </spam>

                            <br />
                            <b className="info-label">Pressão:</b>
                            <br />
                            <spam className="info-text">{ this.state.exam != null && this.state.exam.paSistolic != null && this.state.exam.paDiastolic != null ? this.state.exam.paSistolic+"/"+this.state.exam.paDiastolic  : ""} </spam>

                            <br />
                            <br />

                            {
                              this.state.exam.status == 'EXAM_STATUS_REPORTED' && AuthStore.getState().user.profile == "C" ?
                              <Row>
                                <Col xs="12" md="12">
                                  <h3>Laudo</h3>
                                  {this.state.exam.report}
                                  <br />
                                  <b>Obs: </b>
                                  {this.state.exam.reportObs}
                                </Col>
                              </Row>
                              : ""
                            }

                            {
                              this.state.exam.status == 'EXAM_STATUS_REPORTED' && AuthStore.getState().user.profile == "M" &&
                              this.state.exam.preReport && this.state.exam.preReport.status == "DIVERGENT" ?
                              <Alert color="danger">
                                O pré-laudo deste exame é divergente:
                                <br />
                                <br />
                                <Row>
                                  <Col xs="12" md="12">
                                    <h3>Laudo</h3>
                                    {this.state.exam.report}
                                    <br />
                                    <b>Obs: </b>
                                    {this.state.exam.reportObs}
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col xs="12" md="12">
                                    <h3>Pré-Laudo</h3>
                                    {this.state.exam.preReport.report}
                                    </Col>
                                  </Row>
                              </Alert>
                              : ""
                            }

                        </Col>

                        <Col xs="12" sm="4" md="4">
                            <h5>Paciente</h5>
                            <hr />

                            <b className="info-label">Nome:</b>
                            <br />
                            <spam className="info-text">{this.state.exam.patient.firstname +' '+this.state.exam.patient.lastname}</spam>
                            <br />
                            <b className="info-label">Nome da Mãe:</b>
                            <br />3
                            <spam className="info-text">{this.state.exam.patient.motherName != "" ? this.state.exam.patient.motherName  : "-"} </spam>
                            <br />
                            <b className="info-label">Telefone:</b>
                            <br />
                            <spam className="info-text">{this.state.exam.patient.contactPhone != "" ? this.state.exam.patient.contactPhone : "-"} </spam>
                            <br />
                            <b className="info-label">Documento:</b>
                            <br />
                            <spam className="info-text">{this.state.exam.patient.document} ({this.state.exam.patient.docType})</spam>

                            <hr />
                            <Select
                    					id="state-select"
                    					ref="stateSelect"
                    					autoFocus
                    					options={this.state.anteriorExams}
                    					simpleValue
                    					clearable={this.state.clearable}
                    					name="selected-state"
                    					disabled={this.state.disabled}
                    					value={this.state.anteriorExamSelect}
                    					onChange={this.updateValue}
                    					openOnClick={false}
                    					searchable={this.state.searchable}
                    				/>
                            <br />
                            <Button color="primary"
                            onClick={() => {
                              this.compareExams();
                            }}
                            >
                            <i className="fa fa-exchange"></i>{'\u00A0'} Comparar Exames</Button>

                            <br />
                        </Col>

                        <Col xs="12" sm="4" md="4">
                            <h5>Situação</h5>
                            <hr />

                            {/* <div className={AuthStore.getState().user.profile == "C" ? '' : 'hidden'}>
                              <Button color="success" onClick={function(){this.initChat();}.bind(this)}>
                                <i className="fa fa-comment-alt"></i>{'\u00A0'} Conversar sobre este exame
                              </Button>

                              <br /><br />

                              <Button color="info" className="text-white" onClick={function(){this.generateServiceProtocol();}.bind(this)}>
                                <i className="fa fa-barcode"></i>{'\u00A0'} Gerar Protocolo de atendimento
                              </Button>
                              <br />
                              <b>Protocolo:</b>  {this.state.serviceProtocol != null ? this.state.serviceProtocol.code+"#" : "Nenhum protocolo ativo"}
                              <br />
                              <small>{this.state.serviceProtocol != null ? "Válido até "+this.formatDate(new Date(this.state.serviceProtocol.dtGeneration + (1*60*60*1000))) : ""}</small>

                            </div>
                            <br /> */}

                            <b className="info-label">Registro:</b>
                            <spam className="info-text">{this.state.exam != null ? this.state.exam.publicId : ""}</spam>
                            <br />

                            <b className="info-label">Data Recebimento:</b>
                            <spam className="info-text">{ this.state.exam != null ? dtReceived.getDate() +'/'+ (dtReceived.getMonth()+1) +'/'+ dtReceived.getFullYear() + "  "+
                            dtReceived.getHours() +':'+ dtReceived.getMinutes() +':'+ dtReceived.getSeconds()  : ""} </spam>
                            <br />

                            {this.state.exam.status == "EXAM_STATUS_REPORTED" ?
                            <div>
                              <b className="info-label">Data Laudo:</b>
                              <spam className="info-text">{ dtReported.getDate() +'/'+ (dtReported.getMonth()+1) +'/'+ dtReported.getFullYear() + "  "+
                              dtReported.getHours() +':'+ dtReported.getMinutes() +':'+ dtReported.getSeconds() } </spam>
                              <br />
                            </div>
                            : ""
                            }
                            <b className="info-label">Status:</b>
                            {this.state.exam.repeatExam ? 
                              <spam className="info-text">
                                <Badge color="danger">Reconvocar</Badge>
                                
                                {this.state.exam.report && this.state.exam.report != '' ? 
                                  <div>
                                    <span className="text-danger">{this.state.exam.report}</span>
                                  </div> : ''
                                }
                                
                                {this.state.exam.reportObs && this.state.exam.reportObs != '' ? 
                                  <div>
                                    <span className="text-danger">{this.state.exam.reportObs}</span>
                                  </div> : ''
                                }
                                                                
                              </spam> 
                              : <spam className="info-text">
                                  {this.state.exam != null && this.state.exam.status == 'EXAM_STATUS_REPORTED' ? <Badge color="success">Laudado</Badge> : ''}
                      
                                  {this.state.exam != null && this.state.exam.status == 'EXAM_STATUS_PREREPORTED' && AuthStore.getState().user.profile != "M" ? <Badge color="info">Aguardando Laudo</Badge> : ''}
                                  {this.state.exam != null && this.state.exam.status == 'EXAM_STATUS_PREREPORTED' && AuthStore.getState().user.profile == "M" ? <Badge color="warning">Pré-Laudado</Badge> : ''}

                                  {this.state.exam != null && this.state.exam.status == 'EXAM_STATUS_RECEIVED' ? <Badge color="info">Recebido</Badge> : ''}
                                  {this.state.exam != null && this.state.exam.status == 'EXAM_STATUS_WAITING_REPORT' ? <Badge color="warning">Em Laudo</Badge> : ''}
                               </spam>
                            }
                            

                            <br />
                            <br />

                            {AuthStore.getState().user.profile != "C" ?
                            <div>
                              <h5>Cliente</h5>
                              <br />

                              <div className={AuthStore.getState().user.profile == "M" && (!twilioInstance.isConnected && !twilioInstance.isRinging) ? '' : 'hidden'}>
                                <Button color="success" onClick={function(){twilioInstance.call(this.state.exam.client.phone);}.bind(this)}>
                                  <i className="fa fa-phone"></i>{'\u00A0'} Ligar para este Cliente
                                </Button>
                              </div>

                              <div className={AuthStore.getState().user.profile == "M" && ((twilioInstance.isConnected || twilioInstance.isRinging) && !twilioInstance.incoming ) ? '' : 'hidden'}>
                                <Button color="danger" onClick={function(){twilioInstance.disconnect();}}>
                                  <i className="fa fa-phone"></i>{'\u00A0'} Encerrar ligação
                                </Button>
                              </div>

                              <br />
                              <b className="info-label">Nome:</b>
                              <spam className="info-text">{this.state.exam != null ? this.state.exam.client.name : "-"}</spam>
                              <br />

                              <b className="info-label">Telefone:</b>
                              <spam className="info-text">{this.state.exam != null ? this.state.exam.client.phone : "-"}</spam>

                              <br />
                            </div>
                            : ""}
                            <br />

                            <h5>Solicitante</h5>
                            <hr />

                            <b className="info-label">Nome:</b>
                            <spam className="info-text">{ this.state.exam.requesterName != "" ? this.state.exam.requesterName  : "-"} </spam>
                            <br />

                            <b className="info-label">Telefone:</b>
                            <spam className="info-text">{ this.state.exam.requesterContactPhone != "" ? this.state.exam.requesterContactPhone  : "-"} </spam>
                        </Col>
                    </Row>
                </TabPane>


                <TabPane tabId="2">
                  <div>
                  <Row>
                    <Col xs="6" md="12">
                      <div className={this.state.exam.repeatExam ? '' : 'hidden'}>
                        <Alert color="danger">
                            Exame a repetir. 
                            {this.state.exam.report || this.state.exam.reportObs ? ' - Observações: ' + this.state.exam.report + ' ' + this.state.exam.reportObs : ''}
                        </Alert>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="6" md="12">
                      {
                        this.state.exam.ecgBitmap && isPdf ? <iframe src={ecgBitmapUrl} title="ECG" style={{height: '500px', width: '100%'}}></iframe>
                        : this.state.exam.ecgBitmap && !isPdf ? <img src={this.state.exam.ecgBitmap} style={{width: '100%'}}/>
                        : <EcgPanel derivations={this.state.derivations} onDerivationClick={this.onDerivationClick}
                            ecgSampleRate={this.state.exam == null ? 0 : this.state.exam.ecgSampleRate} ecgResolution={this.state.exam == null ? 0 : this.state.exam.ecgResolution}
                            startFromInit={this.state.equipamentStartFromInit[this.state.exam.client.equipmentType]}/>
                      }
                    </Col>
                  </Row>

                    <br />
                    <Row>
                      <Col xs="6" md="6">

                        <Label htmlFor="cabosInvertidos"></Label>
                        <Input type="checkbox" id="cabosInvertidos" value={this.state.exam.cabosInvertidos}
                          checked={this.state.exam.cabosInvertidos}
                          onChange={evt => {
                          let actualExam = this.state.exam;
                          actualExam.cabosInvertidos = !actualExam.cabosInvertidos;
                          this.setState({exam: actualExam});
                          this.refreshReportText();
                          }}/> Cabos invertidos

                        <br />

                        <Label htmlFor="artefatos"></Label>
                        <Input type="checkbox" id="artefatos" value={this.state.exam.artefatos}
                          checked={this.state.exam.artefatos}
                          onChange={evt => {
                          let actualExam = this.state.exam;
                          actualExam.artefatos = !actualExam.artefatos;
                          this.setState({exam: actualExam});
                          this.refreshReportText();
                          }}/> Artefatos

                          <br />
                          <br />
                          <Row style={{marginLeft:0}}>
                            
                              <div className={this.state.exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
                                <Button color="danger" onClick={() => {
                                  this.refreshReportText();
                                  this.toggleModal();
                                  }}
                                ><i className="fa fa-repeat"></i>{'\u00A0'} Repetir Exame</Button>
                              </div>
                              {this.state.exam.examType == 'EXAM_TYPE_ECG' ?                               
                                <div className={this.state.exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''} style={{marginLeft: '.5rem'}}>
                                  <Button color="success" onClick={this.markAsNormalAndSend} data-tip="Dentro dos limites da normalidade">
                                    <i className="fa fa-check"></i>{'\u00A0'} DLN
                                  </Button>
                                </div>                              
                              : ''}  
                                                                                
                          </Row>
                      </Col>
                    </Row>
                  </div>
                </TabPane>

                {!this.state.exam.ecgBitmap ? 
                <TabPane tabId="3">
                    <Row className="ecg-panel-row">
                        <Col xs="12" sm="12" md="9">
                          <div className="large-ecg-container large-ecg-container-limited-height ecg-wrapper">
                            <div className="large-ecg-inner-container ecg-dragscroll dragscroll">
                              <Ecg ref="ecg" ecgData={this.state.derivations[this.state.reportDerivation]} marks={this.state.marks}
                                  id="ecg-laudo" ref="ecgLaudo" drawGrid={true} drawMarks={true}
                                  totalTime="10" displayTime="10" startFrom="0" ECGLineColor="#005500" traceName={this.state.reportDerivationName}  drawInnerGrid={true}
                                  onMeasurementChange={(measurementsData) => {
                                      this.setState({measurements: measurementsData});

                                       /**
                                       * Verifica a existencia do diagnóstico QT Longo, a partir das seguintes regras:
                                    	 * SEXO MASCULINO e QTc > 450
                                    	 * SEXO FEMININO e QTc > 470
                                    	 */

                                       let qtLongoDetected =
                            						(this.state.exam.patient.gender == 'MALE' && measurementsData.QTc > 450) ||
                            						(this.state.exam.patient.gender == 'FEMALE' && measurementsData.QTc > 470);

                                        let actualExam = this.state.exam;
                                        actualExam.qtLongoDetected = qtLongoDetected;

                                        this.setState({exam: actualExam});
                                    }}
                                  ecgSampleRate={this.state.exam == null ? 0 : this.state.exam.ecgSampleRate} ecgResolution={this.state.exam == null ? 0 : this.state.exam.ecgResolution}/>
                                </div>
                              </div>
                        </Col>

                        <Col xs="12" sm="12" md="3">
                          <Row>
                              <Col xs="6" md="6">
                                  <Label htmlFor="hr">HR (bpm)</Label>
                                  <Input type="text" id="hr" value={this.state.measurements != null ? this.state.measurements.HR.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                              <Col xs="6" md="6">
                                  <Label htmlFor="rr">RR (ms)</Label>
                                  <Input type="text" id="rr" value={this.state.measurements != null ? this.state.measurements.RR.toFixed(2) : ''}/>
                                  <br />
                              </Col>

                              <Col xs="6" md="6">
                                  <Label htmlFor="pr">PR (ms)</Label>
                                  <Input type="text" id="pr" value={this.state.measurements != null ? this.state.measurements.PR.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                              <Col xs="6" md="6">
                                  <Label htmlFor="qrs">QRS (ms)</Label>
                                  <Input type="text" id="qrs" value={this.state.measurements != null ? this.state.measurements.QRS.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                              <Col xs="6" md="6">
                                  <Label htmlFor="qt">QT (ms)</Label>
                                  <Input type="text" id="qt" value={this.state.measurements != null ? this.state.measurements.QT.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                              <Col xs="6" md="6">
                                  <Label htmlFor="qtc">QTc (ms)</Label>
                                  <Input type="text" id="qtc" value={this.state.measurements != null ? this.state.measurements.QTc.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                              <Col xs="6" md="6">
                                  <Label htmlFor="st">ST (mm)</Label>
                                  <Input type="text" id="st" value={this.state.measurements != null ? this.state.measurements.ST.toFixed(2) : ''}/>
                                  <br />
                              </Col>
                          </Row>

                          <Row>
                              <Col xs="12" md="12" className="text-right">
                                  <Button color="success" onClick={()=> {this.setState({tab04enabled: true}); this.toggleTab('4');}}>Confirmar Marcações</Button>
                              </Col>
                          </Row>
                        </Col>
                    </Row>

                    <Row className="row-controls">
                      <Col xs="6" sm="6" className="text-left">
                        <br />
                        <table>
                          <tbody>
                          <tr className={"text-center"}>
                            <td><Label>Ganho</Label></td>
                            <td><Label>Tempo</Label></td>

                          </tr>

                          <tr>
                            <td>
                              <Button color="primary" id={"gain-zoom-up-ecg-laudo"}
                                onClick={() => {this.setState({gainZoom: this.state.gainZoom *2});}}><i className="fa fa-plus"></i>{'\u00A0'}</Button>
                              <Label>{'\u00A0'}{(this.state.gainZoom * 0.25).toFixed(2)}{'\u00A0'}mm/mv</Label>
                              <Button color="primary" id={"gain-zoom-down-ecg-laudo"}
                                onClick={() => {if(this.state.gainZoom > 1) this.setState({gainZoom: this.state.gainZoom / 2});}}><i className="fa fa-minus"></i>{'\u00A0'}</Button>
                            </td>

                            <td>
                              <Button color="success" id={"time-zoom-up-ecg-laudo"}
                                onClick={() => {this.setState({timeZoom: this.state.timeZoom *2});}}><i className="fa fa-plus"></i>{'\u00A0'}</Button>
                              <Label>{'\u00A0'}{(this.state.timeZoom*6.25).toFixed(2)}{'\u00A0'} mm/s</Label>
                              <Button color="success" id={"time-zoom-down-ecg-laudo"}
                              onClick={() => {if(this.state.timeZoom > 1) this.setState({timeZoom: this.state.timeZoom / 2});}}><i className="fa fa-minus"></i>{'\u00A0'}</Button>
                            </td>

                          </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                </TabPane>
                : ""}

                <TabPane tabId="4">

                  <Row>
                      <Col xs="6" md="1">
                          <b>HR</b>: {this.state.measurements != null ? this.state.measurements.HR.toFixed(2) : ''} bpm
                      </Col>
                      <Col xs="6" md="1">
                          <b>RR</b>: {this.state.measurements != null ? this.state.measurements.RR.toFixed(2) : ''} ms
                      </Col>

                      <Col xs="6" md="1">
                          <b>PR</b>: {this.state.measurements != null ? this.state.measurements.PR.toFixed(2) : ''} ms
                      </Col>
                      <Col xs="6" md="1">
                          <b>QRS</b>: {this.state.measurements != null ? this.state.measurements.QRS.toFixed(2) : ''} ms
                      </Col>
                      <Col xs="6" md="1">
                          <b>QT</b>: {this.state.measurements != null ? this.state.measurements.QT.toFixed(2) : ''} ms
                      </Col>
                      <Col xs="6" md="1">
                          <b>QTc</b>: {this.state.measurements != null ? this.state.measurements.QTc.toFixed(2) : ''} ms
                      </Col>
                      <Col xs="6" md="1">
                          <b>ST</b>: {this.state.measurements != null ? this.state.measurements.ST.toFixed(2) : ''} mm
                      </Col>
                  </Row>
                  <br />
                  <br/>
                  <Row>
                    {
                      this.state.exam.examType == 'EXAM_TYPE_ECG' ? 
                      <Col xs="6" >                        
                          <Button color="primary" onClick={this.markAsNormal} active={this.state.exam.normal}>Exame Normal</Button>
                                          
                          <br />

                        <DiagnosticSelect ref="diagnosticSelect" diagnostics={this.state.diagnostics} examType={this.state.exam.examType} clientId={this.state.exam.client.id}
                            onDiagnosticSelect={this.addDiag} 
                            onReportChange={this.refreshReportText}
                            checkCategoryEmpty={this.isCategoryEmpty} checkReportComplete={this.checkReportComplete}
                            selectedByDefault={this.state.exam.status == 'EXAM_STATUS_REPORTED' || this.state.exam.status == 'EXAM_STATUS_PREREPORTED' || this.state.exam.preReport != null}/>                        
                      </Col>
                        : ''
                    }   

                    <Col xs={this.state.exam.examType == 'EXAM_TYPE_ECG' ? "6" : "12"} style={{minHeight: '200px'}}>                        
                      <Row>
                        <Col>
                          <Row style={{marginLeft:0, marginTop: '.5rem'}} >
                            <Label htmlFor="report-text">Laudo</Label>
                            <span className="info-text" style={{marginLeft: '.5rem'}}>
                              {this.state.exam != null && this.state.exam.client != null ? 
                                <Badge color="light">{this.state.exam.client.tier}</Badge> : ''}
                            </span>
                          </Row>
                        </Col>
                        <Col className="text-right" style={{marginBottom: '.5rem'}}>
                          <div className={this.state.exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
                            <Button color="warning" onClick={this.cleanDiagnosticsAndReport} style={{marginRight: '.5rem'}}>Limpar</Button>

                            <Button color="success" onClick={this.sendReport} disabled={!(this.state.reportText != null && this.state.reportText != "")}>Enviar Laudo</Button>
                          </div>
                        </Col>
                      </Row>

                      <Input type="textarea" name="report-text" id="report-text" style={{height: '85%'}}
                        value={this.state.reportText} onChange={this.reportTextChange}/>                          
                    </Col>
                  </Row>

                  <Row>
                    <br/>
                    <Col md="12" sm="12"  style={{marginTop: '20px'}}>
                      <Label htmlFor="obs">Observações</Label>
                      <Input type="textarea" name="obs" id="obs"
                      value={this.state.obs} onChange={this.obsChange} />
                    </Col>
                  </Row>
                </TabPane>
				
				<TabPane tabId="5">
                  <div>
					  <Row>
						<Col xs="12" md="12">
							<label className="text-danger danger">ATENÇÃO: A utilização desta funcionalidade é recomendada apenas em casos de extrema necessidade.</label>
						</Col>
					  </Row>
					  
					  <Row>
                            <Col md="6" sm="12">
                              <Label htmlFor="report-text">Laudo</Label>
                              <Input type="textarea" name="report-text" id="report-text-manual"
                              value={this.state.reportText} onChange={this.reportTextChange}/>
                            </Col>

                            <Col md="6" sm="12">
                              <Label htmlFor="obs">Observações</Label>
                              <Input type="textarea" name="obs" id="obs-manual"
                              value={this.state.obs} onChange={this.obsChange} />
                            </Col>
                          </Row>
						  
						  <Row>
                            <Col md="6" sm="12"></Col>
                            <Col md="6" sm="12" className="text-right">
                              <br />
                              <div className={this.state.exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
                                <Button color="success" onClick={this.sendManualReport} disabled={!(this.state.reportText != null && this.state.reportText != "")}>Enviar Laudo</Button>
                              </div>
                            </Col>
                          </Row>
				  </div>
				</TabPane> 
            </TabContent>

            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />

            <Modal isOpen={this.state.modalRepeatExam} toggle={this.toggleModal} className="info">
              <ModalHeader toggle={this.toggleModal}>Repetir Exame</ModalHeader>
                <ModalBody>
                <Row>
                    <Col xs="12" md="12">
                        <Label>{this.state.reportText}</Label>
                    </Col>
                    <Col xs="12" md="12">
                      <Label htmlFor="obs">Observações</Label>
                      <Input type="textarea" name="obs" id="obs"
                      value={this.state.obs} onChange={this.obsChange} />
                    </Col>
                  </Row>
              </ModalBody>

              <ModalFooter>
                <Button color="success" onClick={() => {
                              let actualExam = this.state.exam;
                              actualExam.repeatExam = true;
                              this.setState({exam: actualExam});
                              this.sendReport();
                              this.toggleModal();
                              }}>Enviar Laudo</Button>
                <Button color="danger" onClick={this.toggleModal}>Cancelar</Button>
              </ModalFooter>
            </Modal>


            <Modal isOpen={this.state.modalCompareExam} toggle={this.toggleModalCompareExams} className="info" size="lg">
              <ModalHeader toggle={this.toggleModalCompareExams}>Comparação de Exames</ModalHeader>
                <ModalBody>
                  <b>Paciente:</b>
                  <Row>
                    <Col md="6">
                      Nome: {this.state.comparableExam == null ? "" : this.state.comparableExam.patient.firstname +" "+ this.state.comparableExam.patient.lastname}
                    </Col>
                    <Col md="2">
                      Idade: {this.state.comparableExam == null ? "" : this.getAge(this.state.comparableExam.patient.dtBirthDate)}
                    </Col>
                    <Col md="2">
                      Sexo: {this.state.comparableExam == null ? "" : (this.state.comparableExam.patient.gender == "FEMALE" ? "Feminino": "Masculino")}
                    </Col>
                  </Row>

                  <hr />

                  <Row>
                    <Col md="3">
                      <b>Exame Anterior</b>
                    </Col>
                    <Col md="4">
                      Registro: {this.state.comparableExam == null ? "" : this.state.comparableExam.publicId}
                    </Col>
                    <Col md="5">
                      Recepção: {this.state.comparableExam == null ? "" : this.formatDate(new Date(this.state.comparableExam.dtReceived))}
                    </Col>
                  </Row>
                  <Row className="row-no-padding row-bordered ecg-panel-row ">
                      <Col xs="12" sm="12">
                      {
                        this.state.comparableExamDerivations == null ? null :
                        (
                          <Ecg ecgData={this.state.comparableExamDerivations[this.state.comparableExamDerivation]} id="comparable-derivation" drawGrid={true} drawMarks={false}
                          totalTime="10" displayTime="10" ECGLineColor="#005500" traceName={derivationNames[this.state.comparableExamDerivation]}
                          ref={"comparable-derivation-"+this.state.comparableExamDerivation}
                          ecgSampleRate={this.state.comparableExam == null ? 0 : this.state.comparableExam.ecgSampleRate}
                          ecgResolution={this.state.comparableExam == null ? 0 : this.state.comparableExam.ecgResolution} />
                        )
                      }
                      </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xs="4" sm="6">
                      <Select
                        options={
                          [{value: 0, label:"I"}, {value: 1, label:"II"}, {value: 2, label:"III"}, {value: 3, label:"aVR"}, {value: 4, label:"aVL"}, {value: 5, label:"aVF"},
                            {value: 6, label:"V1"},{value: 7, label:"V2"}, {value: 8, label:"V3"}, {value: 9, label:"V4"}, {value: 10, label:"V5"}, {value: 10, label:"V6"} ]
                        }
                        simpleValue
                        value={this.state.comparableExamDerivation}
                        onChange={this.updateValueComparableExamDerivation}
                        openOnClick={false}
                      />
                      </Col>
                  </Row>

                  <hr />

                  <Row>
                    <Col md="3">
                      <b>Exame Atual</b>
                    </Col>
                    <Col md="4">
                      Registro: {this.state.exam == null ? "" : this.state.exam.publicId}
                    </Col>
                    <Col md="5">
                      Recepção: {this.state.exam == null ? "" : this.formatDate(new Date(this.state.exam.dtReceived))}
                    </Col>
                  </Row>

                  <Row className="row-no-padding row-bordered ecg-panel-row ">
                      <Col xs="12" sm="12">
                      {
                        this.state.derivations == null ? null :
                        (
                          <Ecg ecgData={this.state.derivations[this.state.comparableExamDerivation]} id="actual-exam-derivation" drawGrid={true} drawMarks={false}
                          totalTime="10" displayTime="10" ECGLineColor="#005500" traceName={derivationNames[this.state.comparableExamDerivation]}
                          ref={"actual-exam-"+this.state.comparableExamDerivation}
                          ecgSampleRate={this.state.exam == null ? 0 : this.state.exam.ecgSampleRate}
                          ecgResolution={this.state.exam == null ? 0 : this.state.exam.ecgResolution} />
                        )
                      }
                      </Col>
                  </Row>

                </ModalBody>

              <ModalFooter>
                <Button color="danger" onClick={this.toggleModalCompareExams}>Fechar</Button>
              </ModalFooter>
            </Modal>

            </div>
        )
    }
}

export default ExamViewer;



// WEBPACK FOOTER //
// ./src/views/Components/ExamViewer/ExamViewer.js